import {
  BookingSetting,
  Reservation,
  ReservationStatus,
  UpsertBookingSettingPayload,
} from '@core/models';
import axios from 'axios';

export interface NewGenericReservationPayload {
  email: string | undefined;
  phone: string | undefined | null;
  firstName: string;
  lastName: string;
  reservedDate: number;
  reservationStatus: ReservationStatus;
  numberOfPeople: number;
}

export default class BookingApiService {
  private url = `${process.env.REACT_APP_GOOGLE_OAUTH_ENDPOINT}/booking`;

  async createNewReservation<T>(
    locationId: string,
    payload: NewGenericReservationPayload
  ): Promise<Reservation<T>> {
    try {
      const response = await axios.post(`${this.url}/${locationId}`, payload, {
        withCredentials: true,
      });
      return response.data;
    } catch (error: any) {
      throw new Error(error);
    }
  }

  async skipReservation<T>(reservationId: number): Promise<Reservation<T>> {
    try {
      const response = await axios.post(
        `${this.url}/${reservationId}/skip`,
        {},
        {
          withCredentials: true,
        }
      );
      return response.data;
    } catch (error: any) {
      throw new Error(error);
    }
  }

  async finishReservation<T>(reservationId: number): Promise<Reservation<T>> {
    try {
      const response = await axios.post(
        `${this.url}/${reservationId}/finish`,
        {},
        {
          withCredentials: true,
        }
      );
      return response.data;
    } catch (error: any) {
      throw new Error(error);
    }
  }

  async serveReservation<T>(reservationId: number): Promise<Reservation<T>> {
    try {
      const response = await axios.post(
        `${this.url}/${reservationId}/serve`,
        {},
        {
          withCredentials: true,
        }
      );
      return response.data;
    } catch (error: any) {
      throw new Error(error);
    }
  }

  async deleteReservation<T>(reservationId: number): Promise<Reservation<T>> {
    try {
      const response = await axios.delete(`${this.url}/${reservationId}`, {
        withCredentials: true,
      });
      return response.data;
    } catch (error: any) {
      throw new Error(error);
    }
  }

  async updateReservation<T>(
    reservationId: number,
    params: Partial<NewGenericReservationPayload>
  ): Promise<Reservation<T>> {
    try {
      const response = await axios.put(
        `${this.url}/${reservationId}`,
        {
          ...params,
        },
        {
          withCredentials: true,
        }
      );
      return response.data;
    } catch (error: any) {
      throw new Error(error);
    }
  }

  async getLocationReservations<T>(): Promise<Reservation<T>[]> {
    try {
      const response = await axios.get(`${this.url}/`, {
        withCredentials: true,
      });
      return response.data;
    } catch (error: any) {
      throw new Error(error);
    }
  }

  async getBookingSetting(): Promise<BookingSetting> {
    try {
      const response = await axios.get(`${this.url}/setting`, {
        withCredentials: true,
      });
      return response.data;
    } catch (error: any) {
      throw new Error(error);
    }
  }

  async updateBookingSetting(params: UpsertBookingSettingPayload): Promise<void> {
    try {
      const response = await axios.put(`${this.url}/setting`, params, {
        withCredentials: true,
      });
      return response.data;
    } catch (error: any) {
      throw new Error(error);
    }
  }
}
